import { PaymentOptionApiModel, PaymentOptionType } from '~/lib/api/smartsend/types';

export default function PaymentOptionAnalyser(options: PaymentOptionApiModel[], value: number): PaymentOptionType {
  if (options.find((x) => x.Type === 'Invoiced')) {
    return 'Invoiced';
  }

  if (options.find((x) => x.Type === 'CourierAccount')) {
    return 'CourierAccount';
  }

  const topUp = options.find((x) => x.Type === 'TopUp');
  if (topUp && Number(topUp.Balance) >= Number(value)) {
    return 'TopUp';
  }

  if (options.find((x) => x.Type === 'SavedPayment')) {
    return 'SavedPayment';
  }

  if (options.find((x) => x.Type === 'External')) {
    return 'External';
  }

  if (topUp) {
    return 'TopUp';
  }
  return null;
}
